<ng-container *ngIf="dataSource">
  <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">
    >
    <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="menu-tree-node">
      <a
        class="node depth-{{ node.depth }}"
        [routerLink]="node.url"
        routerLinkActive="active"
        [class.active-ascendent]="isActive(node)"
        (click)="nodeSelected.emit()"
      >
        <span>{{ node.name }}</span>
      </a>
    </cdk-nested-tree-node>
    <cdk-nested-tree-node
      *cdkTreeNodeDef="let node; when: hasChildren"
      class="menu-tree-node mat-headline-4-2"
    >
      <a
        [attr.aria-label]="'Toggle ' + node.name"
        cdkTreeNodeToggle
        class="node depth-{{ node.depth }}"
        [class.active-ascendent]="isActive(node)"
        (click)="collapseNodes(node)"
      >
        <span>{{ node.name }}</span>
        <fa-icon [icon]="treeControl.isExpanded(node) ? 'chevron-up' : 'chevron-down'"></fa-icon>
      </a>
      <div class="children" [@menuAccordian]="treeControl.isExpanded(node) ? 'show' : null">
        <a
          [routerLink]="node | taxonUrl: (showTaxonsOnMobile(node) ? 'taxon' : 'pl')"
          routerLinkActive="active"
          class="node view-all"
          (click)="nodeSelected.emit()"
        >
          <span i18n="@@CallToAction.ViewallToTaxon" *ngIf="showTaxonsOnMobile(node); else ELSE">
            View all {{ node.name }}
          </span>
          <ng-template #ELSE>
            <span i18n="@@CallToAction.ViewAll">View All</span>
          </ng-template>
        </a>

        <ng-container cdkTreeNodeOutlet></ng-container>
      </div>
    </cdk-nested-tree-node>
  </cdk-tree>
</ng-container>
